import type { ComponentPropsWithRef, ReactNode } from 'react'
import { forwardRef } from 'react'

import { Button } from '@adverity/ds-component/button'
import { IconCloseLarge } from '@adverity/ds-icon'

import { useSlotProps } from '~/utils/components/slots'

import { headerFooterHeight } from './dialog'
import { Flex } from '../flex/flex'

type Props = {
    children: ReactNode
    onClose: () => void
} & ComponentPropsWithRef<typeof Flex>

export const DialogHeader = forwardRef<HTMLElement, Props>(({ onClose, children, ...props }, ref) => {
    const { id, 'aria-label': ariaLabel, ...slotProps } = useSlotProps(props, 'header')

    return (
        <Flex
            ref={ref}
            minHeight={headerFooterHeight}
            paddingX="medium"
            alignItems="center"
            justifyContent="space-between"
            css={{ whiteSpace: 'nowrap' }}
            {...slotProps}
        >
            <Flex id={id} aria-label={ariaLabel} width="100%">
                {children}
            </Flex>
            <Button
                variant="minimal"
                color="neutral"
                size="small"
                rounded
                label="Close"
                icon={<IconCloseLarge />}
                onClick={onClose}
                // oxlint-disable-next-line @adverity/oxlint/no-color-classname -- inherit from CSSScope so headerTheme (e.g. inverted) drives the icon color
                className="text-inherit!"
            />
        </Flex>
    )
})

DialogHeader.displayName = 'DialogHeader'
